module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('div', {
    staticClass: "col s12"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.form
    }
  }, [_vm._v("Loading&#8230;")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-521185fa!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/page/Purchase.vue
// module id = 77
// module chunks = 0